import React from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../../theme'
import ExpandButton from '../Buttons/ExpandButton'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

export const StyledSection = styled.div<
  IExpandableFormStyle & ITheme & IWithSize
>`
  border-bottom: ${props =>
    props.withBorder
      ? `1px solid ${props.theme.colors.palette.greyTwo}`
      : `none`};
  padding-bottom: ${props =>
    props.withBorder ? (props.size ? `${15 * props.size}px` : '15px') : '0'};
  margin-bottom: ${({ size }) => (size ? 15 * size : 15)}px;
`

interface IExpandableFormStyle {
  withBorder?: boolean
}

function ExpandableFormSection({
                                 initialInput,
                                 size = 1,
                                 children,
                                 expanded = false,
                                 withBorder = false,
                               }: IExpandableFormSectionProps) {
  const [expand, toggleExpand] = React.useState(expanded)

  function toggle() {
    toggleExpand(!expand)
  }

  return (
    <StyledSection size={size} withBorder={withBorder}>
      <Flex
        alignCenter={true}
        style={{
          height: `${42 * size}px`,
        }}
      >
        {initialInput}
        <ExpandButton size={size} onClick={toggle}>
          {!expand ? (
            <FiChevronDown size={22 * size}/>
          ) : (
            <FiChevronUp size={22 * size}/>
          )}
        </ExpandButton>
      </Flex>
      <Flex>{expand && children}</Flex>
    </StyledSection>
  )
}

export default ExpandableFormSection

export interface IExpandableFormSectionProps {
  initialInput: React.ReactNode
  children: React.ReactNode | React.ReactNode[]
  expanded?: boolean
  size?: number
  withBorder?: boolean
}
